module.exports = __webpack_public_path__ + "img/userCenter.38eadc02.png";